import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { BmsDataCollectorViewData } from '@app/core/models/bms-data-collector-view-data';
import { BmsDataCollectorComponent } from '../../../bms-data-collector-view.component';
import { BmsSystemObjectsService } from '../../../services/bms-system-objects-service';
import { BmsSystemObjectCurve } from '@app/features/bms/models/bms-system-object-curve';
import { ClrLoadingState } from '@clr/angular';
import { Chart } from 'chart.js';
import dragDataPlugin from 'chartjs-plugin-dragdata';

@Component({
  selector: 'app-bms-system-object-curve-view',
  templateUrl: './bms-system-object-curve-view.component.html',
  styleUrls: ['./bms-system-object-curve-view.component.scss']
})
export class BmsSystemObjectCurveViewComponent implements OnInit, BmsDataCollectorComponent {

  @ViewChild("curveGraphCanvas", { read: ElementRef, static: false }) curveGraphCanvas: ElementRef;

  private systemObjectsService : BmsSystemObjectsService = inject(BmsSystemObjectsService);

  public static NodeTypeId : string = '_x_bms_systems_objectcurve';

  data: BmsDataCollectorViewData;
  visible: boolean;

  responsiveWidth : number = 600;

  curve : BmsSystemObjectCurve;
  curveGraphChart : any

  loading : ClrLoadingState = ClrLoadingState.DEFAULT;
  curveEdit : boolean = false;

  constructor() { }

  ngOnInit() {
  }

  async initDataCollectorView() {
    this.responsiveWidth = this.data.width;
    if (this.data.node) {
      this.curve = await this.systemObjectsService.getSystemObjectCurve(this.data.node.id);
      setTimeout(() => {
        this.updateCurveGraph(false);
      });

    }
  }

  setWidth(width: number) {
    if (this.data) {
      this.data.width = width;
    }

    this.responsiveWidth = width;
  }

  async save() {
    if (this.curve) {
      try {
        this.loading = ClrLoadingState.LOADING;

        let response = await this.systemObjectsService.saveSystemObjectCurve(this.curve, this.data.customer?.id, this.data.node);
        if (response.result) {
          this.curveEdit = false;
        }
      }
      finally {
        this.loading = ClrLoadingState.SUCCESS;
      }
    }
  }

  updateCurveGraph(curveEditState : boolean = true) {

    let labels : number[] = [];
    let values : number[] = [];
    let min = 1000;
    let max = -1000;

    for (let i = 1; i <= this.curve.points; i++) {
      labels.push(this.curve['in' + i]);
      values.push(this.curve['out' + i]);
      if (values[i-1] < min) {
        min = values[i-1];
      }
      if (values[i-1] > max) {
        max= values[i-1];
      }
    }

    if (!this.curveGraphChart) {
      let canvas = this.curveGraphCanvas.nativeElement as HTMLCanvasElement;

      let data = {
        labels: labels,
        datasets: [
          {
            data: values,
            borderColor: '#1f77b4',
            backgroundColor: '#1f77b4',
            pointRadius: 4
          }
        ]
      };

      let that = this;

      this.curveGraphChart = new Chart(canvas,
        {
          type: 'line',
          data: data,
          plugins: [dragDataPlugin],
          options: {
            responsive: true,
            scales: {
              y: {
                suggestedMin: min - 10,
                suggestedMax: max + 10
              }
            },
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: false,
              },
              dragData: {
                dragX: false,
                dragY: true,
                round: 0,
                showTooltip: true,
                onDragEnd: function (event, datasetIndex, index, value) {
                  if (that.curve) {
                    that.curve['out' + (index+1)] = value;
                    that.curveEdit = true;
                  }
                },
              },
            }
          }
        }
      )
    }
    else {
      this.curveGraphChart.data.labels = labels;
      this.curveGraphChart.data.datasets[0].data = values;
      this.curveGraphChart.update();
    }

    this.curveEdit = curveEditState;
  }

}
